 <template>
  <v-container
    grid-list-xs
    class="d-flex justify-center align-center my-10 fill-height"
  >
    <v-card class="card-width card-radius card-shadow my-16" elevation="0">
      <v-card-title
        primary-title
        class="dark-blue white--text title font-weight-medium px-10"
        >Oopps!</v-card-title
      >
      <v-container class="py-8">
        <div class="content px-5">
          <div
            style="border-radius: 10px; background-color: #f2b6b6"
            class="pa-3"
          >
            <v-row align="center px-5">
              <div class="ml-3">Email belum terverifikasi, silakan cek email Anda.</div>
            </v-row>
          </div>
          <v-btn
            style="width: 100%"
            class="mt-5 dark-blue white--text py-5"
            :disabled="disabled"
            @click="verifyEmail"
            >Verifikasi Email</v-btn
          >
          <v-btn
            style="width: 100%"
            class="mt-5 dark-blue white--text py-5"
            @click="resendEmail"
            >Kirim Ulang Verifikasi</v-btn
          >
        </div>
      </v-container>
    </v-card>
    <v-snackbar :color="color" v-model="snackbar" :timeout="timeout">
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
import { EventBus } from "../event-bus";

export default {
  name: "EmailVerification",
  data: () => ({
    snackbar: false,
    text: "Verifikasi email telah dikirim ulang.",
    timeout: 5000,
    color: "green",
    disabled: true,
    expires: "",
    hash: "",
    signature: "",
    id: "",
  }),
  mounted() {
    var route = this.$route.query;
    this.expires = route.expires;
    this.hash = route.hash;
    this.signature = route.signature;
    this.id = this.$route.params.id;

    if (
      this.expires != undefined &&
      this.hash != undefined &&
      this.signature != undefined
    ) {
      this.disabled = false;
    }
  },
  methods: {
    async resendEmail() {
      EventBus.$emit("startLoading");
      const res = await axios.post(`${this.$api}/email/resend`);
      if (res.data["STATUS"] == "SUCCESS") {
        var email = localStorage.getItem('username');
        this.text = `Verifikasi email telah dikirim ulang ke ${email}.`;
        this.color = "green";
        this.snackbar = true;
      } else {
        this.text = res.data["MESSAGE"];
        this.color = "red";
        this.snackbar = true;
      }
      EventBus.$emit("stopLoading");
    },
    async verifyEmail() {
      EventBus.$emit("startLoading");
      var expire = this.expires;
      var hash = this.hash;
      var signature = this.signature;
      var id = this.id;
      try {
        const res = await axios.get(`${this.$api}/email/verify/${id}`, {
          params: {
            expires: expire,
            hash: hash,
            signature: signature,
          },
        });
        if (res.data["STATUS"] == "SUCCESS") {
          this.text = res.data["MESSAGE"];
          this.color = "green";
          this.snackbar = true;
          localStorage.setItem("isVerified", true);
          setTimeout(() => {
            this.$router.push({ name: "home" });
          }, 1000);
        } else {
          this.text = res.data["MESSAGE"];
          this.color = "red";
          this.snackbar = true;
        }
      } catch (e) {
        this.text = e;
        this.color = "red";
        this.snackbar = true;
      }
      EventBus.$emit("stopLoading");
    },
  },
};
</script>


<style scoped>
.dark-blue {
  background-color: #24305e !important;
}

.card-text {
  font-size: 1.2rem;
}

.card-radius {
  border-radius: 10px !important;
}

.card-width {
  width: 40%;
}

.card-shadow {
  box-shadow: -2px -2px 4px rgba(0, 0, 0, 0.08), 2px 2px 4px rgba(0, 0, 0, 0.08) !important;
}

.berkas-section {
  min-height: 80vh;
}

@media screen and (max-width: 600px) {
  .card-width {
    width: 100%;
  }
}
</style>